import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import SalesforceCloudCheckJson from 'images/SalesforceCloudCheck.json';

export const SalesforceCloudCheck: React.FC = () =>
	<Player
		autoplay
		keepLastFrame
		src={ SalesforceCloudCheckJson } />;
